"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAILWIND_CLASSES = void 0;
exports.TAILWIND_CLASSES = {
    HIDDEN: 'hidden',
    FLEX: 'flex',
    OVERFLOW_HIDDEN: 'overflow-hidden',
    OPACITY_100: 'opacity-100',
    OPACITY_0: 'opacity-0',
    Z_1: 'z-1',
    TEXT_DISABLE: '!text-disable',
    PSEUDO_AFTER_ARROW_DISABLED: 'after:border-disable',
    SEARCH_TAB_BUTTON_ACTIVE: 'search-tab-button-active',
    TOP_TAB_BUTTON_ACTIVE: 'top-tab-button-active',
    OPEN: 'open',
    RADIO_WRAPPER: 'radio-wrapper',
    BUTTON_DISABLED: 'button-disabled',
    BG_ERROR: 'bg-error',
    BORDER_ERROR: '!border-error',
    MODAL: [
        'hidden',
        'items-center',
        'justify-center',
        'fixed',
        'inset-0',
        'size-full',
        'z-[999999]',
        'opacity-0',
        'transition-opacity',
    ],
    MODAL_OVERLAY: ['fixed', 'inset-0', 'size-full', 'bg-black', 'opacity-55'],
};
